import { getProps } from "@up/data";

import Page from "../[uid]";

export async function getStaticProps(context) {
  return getProps(context, "college-credit");
}

export default Page;
